import PythonApi from "../services/PythonApi";

export default {
  get({bolusID, withBolusPh}) {
    const params = new URLSearchParams()
    const url = `boluses/${bolusID}`;

    if (withBolusPh)
      params.append('with_bolus_ph', true);

    return PythonApi().get(url, params);
  },
  list({availableOnly, withBolusPh, bolusException}) {
    const params = new URLSearchParams()
    const url = "boluses";

    if (availableOnly)
      params.append('available_only', true);
      if (bolusException)
        params.append('bolus_exception', bolusException);

    if (withBolusPh)
      params.append('with_bolus_ph', true);

    return PythonApi().get(url, params);
  },
  updateCalibration(payload) {
    return PythonApi().put('bolus/calibration', payload);
  },
  post(bolus) {
    return PythonApi().post('boluses', bolus)
  },
  put(bolus) {
    return PythonApi().put(`boluses/${bolus.bolus_id}`, bolus)
  },
  delete(bolusID) {
    return PythonApi().delete(`boluses/${bolusID}`)
  },
  uploadBoluses(boluses) {
    return PythonApi().post('boluses/upload-boluses', boluses)
  },
  updateActivationDates(actDateData) {
    if (!actDateData.bolus_ids || !actDateData.activation_date) {
      return;
    }
    return PythonApi().put('boluses/update-activation-dates', actDateData)
  },
  deletePhConfig(bolus_ph_config_id) {
    return PythonApi().delete(`boluses/ph-config/${bolus_ph_config_id}`, new URLSearchParams())
  }
};



// WEBPACK FOOTER //
// ./src/api/bolus-api.js